<template>
  <div class="u-page" :class="[platform, !device.isInApp ? 'h5' : '']">
    <div class="header-container" v-if="device.isInApp || user.role == 8">     <!--<slot name="nav" >-->
      <slot v-if="platform !== 'web'" name="m-nav">
        <div class="header-inner">
          <slot name="m-nav-left">
            <button @click="back" class="iconfont  icon-leiappreturn m-nav-left"></button>
          </slot>
          <slot name="m-nav-center">
            <div class="title">
              {{title}}
            </div>
          </slot>
          <div class="m-nav-right" :class="$t('m.LangCss')">
            <slot name="m-nav-right">
            </slot>
          </div>
        </div>
      </slot>
    </div>
    <div class="header-container" v-if="platform === 'web'">
      <slot name="header-main">
        <div class="header-content">
          <slot name="header-left">
          </slot>
          <slot name="header-info">
            <span class="header-title">{{title}}</span>
          </slot>
          <slot name="header-action">
            <div class="header-action">
              <slot name="header-link">
              </slot>
              <slot name="header-backaction">
                <a @click="back" class="header-back">{{$t('m.BACK')}}</a>
              </slot>
            </div>
          </slot>
        </div>
      </slot>
    </div>
    <div class="content-container" :class="className">
      <slot v-if="platform === 'web'" name="content"></slot>
      <div v-if="platform === 'web'" class="footer-container">
        <slot name="footer">
        </slot>
      </div>
      <div class="content-container-mobile" v-if="platform !== 'web'" style="height: 100%">
        <cube-scroll :class="[umscroll]" ref="umScroll">
          <slot name="content"></slot>
        </cube-scroll>
      </div>

    </div>
    <div v-if="platform !== 'web'" class="footer-container">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import { getPlatform } from './../utils/platform'
  import { exitApp } from 'common/js/mobilePlugin'
  import UAccoutService from 'common/js/UAccoutService'
//  import { Scroll } from 'cube-ui'
  import BScroll from 'better-scroll'
  import Vue from 'vue'

  export default {
    created () {
      this.platform = getPlatform().platform
      if (getPlatform().isMobile) {
        this.platform = `${this.platform} mobile`
      }
    },
    beforeCreate: function () {
      if (getPlatform().platform === 'web') {
        document.getElementsByTagName('body')[0].className = 'p-homeworkwrap'
      }
    },
    props: {
//       标题
      title: {
        type: String,
        default: '',
        required: false
      },
      umCanScroll: {
        type: Boolean,
        default: false
      },
      ulStopDefaultBack: {
        type: Boolean,
        default: false
      },
      isDetails: {
        type: Boolean,
        default: false
      },
      className: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
//       平台属性
        platform: '',
        device: getPlatform()
      }
    },
    activated () {
      if (this.$refs.umScroll) {
        Vue.nextTick(() => {
          this.$refs.umScroll.destroy()
          this.$refs.umScroll.initScroll()
        })
      }
    },
    methods: {
      back () {
        function getHashParam (name) {
          /* eslint-disable */
          let reg = new RegExp('(^|\\?|&)' + name + '=([^(&|\/)]*)(&|\/|$)')
          let r = window.location.hash.substr(1).match(reg)
          if (r != null) return decodeURI(r[2])
          return null
        }
        if (getHashParam('ub2') === '1' && getPlatform().platform === 'web') {
          this.$emit('onMBack')
          if (!this.ulStopDefaultBack) {
            window.close()
          }
        } else {
          this.$emit('onMBack')
          if (!this.ulStopDefaultBack&&window.location.hash.indexOf('scoreRule') ==-1) {
            if (getPlatform().isMobile) {
              window.history.length > 1 ? this.$router.go(-1) : exitApp()
            } else {
              this.$router.back()
            }
          }
        }
      },
      refresh(){
        this.$refs.umScroll.refresh()
      },
      scrollTop(){
        this.$refs.umScroll.scrollTo(0,0,0)
      }
    },
    mounted () {
//      if (!this.platform.isMobile) return

      /* eslint-disable */
      var TOUCH_EVENT = 1
      var MOUSE_EVENT = 2

      var eventType = {
        touchstart: TOUCH_EVENT,
        touchmove: TOUCH_EVENT,
        touchend: TOUCH_EVENT,

        mousedown: MOUSE_EVENT,
        mousemove: MOUSE_EVENT,
        mouseup: MOUSE_EVENT
      }
      var DIRECTION_UP = 1
      var DIRECTION_DOWN = -1
      var DIRECTION_LEFT = 1
      var DIRECTION_RIGHT = -1

      var PROBE_DEBOUNCE = 1

      var PROBE_REALTIME = 3

      function getNow () {
        return window.performance && window.performance.now ? window.performance.now() + window.performance.timing.navigationStart : +new Date()
      }

      function preventDefaultException (el, exceptions) {
        for (var i in exceptions) {
          if (exceptions[i].test(el[i])) {
            return true
          }
        }
        return false
      }

      BScroll.prototype._move = function (e) {
        if (!this.enabled || this.destroyed || eventType[e.type] !== this.initiated) {
          return
        }
        if (this.options.preventDefault && !preventDefaultException(e.target, this.options.preventDefaultException)) {
          e.preventDefault()
        }
        if (this.options.stopPropagation) {
          e.stopPropagation()
        }

        var point = e.touches ? e.touches[0] : e
        var deltaX = point.pageX - this.pointX
        var deltaY = point.pageY - this.pointY

        this.pointX = point.pageX
        this.pointY = point.pageY

        this.distX += deltaX
        this.distY += deltaY

        var absDistX = Math.abs(this.distX)
        var absDistY = Math.abs(this.distY)

        var timestamp = getNow()

        // We need to move at least momentumLimitDistance pixels for the scrolling to initiate
        if (timestamp - this.endTime > this.options.momentumLimitTime && absDistY < this.options.momentumLimitDistance && absDistX < this.options.momentumLimitDistance) {
          return
        }

        // If you are scrolling in one direction lock the other
        if (!this.directionLocked && !this.options.freeScroll) {
          if (absDistX > absDistY + this.options.directionLockThreshold) {
            this.directionLocked = 'h' // lock horizontally
          } else if (absDistY >= absDistX + this.options.directionLockThreshold) {
            this.directionLocked = 'v' // lock vertically
          } else {
            this.directionLocked = 'n' // no lock
          }
        }

        if (this.directionLocked === 'h') {
          if (this.options.eventPassthrough === 'vertical') {
            e.preventDefault()
          } else if (this.options.eventPassthrough === 'horizontal') {
            this.initiated = false
            return
          }
          deltaY = 0
        } else if (this.directionLocked === 'v') {
          if (this.options.eventPassthrough === 'horizontal') {
            e.preventDefault()
          } else if (this.options.eventPassthrough === 'vertical') {
            this.initiated = false
            return
          }
          deltaX = 0
        }

        deltaX = this.hasHorizontalScroll ? deltaX : 0
        deltaY = this.hasVerticalScroll ? deltaY : 0
        this.movingDirectionX = deltaX > 0 ? DIRECTION_RIGHT : deltaX < 0 ? DIRECTION_LEFT : 0
        this.movingDirectionY = deltaY > 0 ? DIRECTION_DOWN : deltaY < 0 ? DIRECTION_UP : 0

        var newX = this.x + deltaX
        var newY = this.y + deltaY

        // Slow down or stop if outside of the boundaries
        var _options$bounce = this.options.bounce,
          _options$bounce$top = _options$bounce.top,
          top = _options$bounce$top === undefined ? true : _options$bounce$top,
          _options$bounce$botto = _options$bounce.bottom,
          bottom = _options$bounce$botto === undefined ? true : _options$bounce$botto,
          _options$bounce$left = _options$bounce.left,
          left = _options$bounce$left === undefined ? true : _options$bounce$left,
          _options$bounce$right = _options$bounce.right,
          right = _options$bounce$right === undefined ? true : _options$bounce$right

        if (newX > 0 || newX < this.maxScrollX) {
          if (newX > 0 && left || newX < this.maxScrollX && right) {
            newX = this.x + deltaX / 3
          } else {
            newX = newX > 0 ? 0 : this.maxScrollX
          }
        }
        if (newY > 0 || newY < this.maxScrollY) {
          if (newY > 0 && top || newY < this.maxScrollY && bottom) {
            newY = this.y + deltaY / 3
          } else {
            newY = newY > 0 ? 0 : this.maxScrollY
          }
        }

        if (!this.moved) {
          this.moved = true
          this.trigger('scrollStart')
        }

        this._translate(newX, newY)

        if (timestamp - this.startTime > this.options.momentumLimitTime) {
          this.startTime = timestamp
          this.startX = this.x
          this.startY = this.y

          if (this.options.probeType === PROBE_DEBOUNCE) {
            this.trigger('scroll', {
              x: this.x,
              y: this.y
            })
          }
        }

        if (this.options.probeType > PROBE_DEBOUNCE) {
          this.trigger('scroll', {
            x: this.x,
            y: this.y
          })
        }

        var scrollLeft = document.documentElement.scrollLeft || window.pageXOffset || document.body.scrollLeft
        var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop

        var pX = this.pointX - scrollLeft
        var pY = this.pointY - scrollTop

        if (pX > document.documentElement.clientWidth - this.options.momentumLimitDistance || pX < this.options.momentumLimitDistance || pY < this.options.momentumLimitDistance || pY > document.documentElement.clientHeight - this.options.momentumLimitDistance) {
          this._end(e)
        }
      }
    },
    computed: {
      umscroll () {
        return this.umCanScroll ? 'um-scroll' : ''
      },
      user() {
        return UAccoutService.getAccount()
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "./../stylus/variable.styl"
  .p-homeworkwrap
    background-color #F3F3F3
    .cube-popup-content
      max-width: 100%

  .u-page
    padding: 0px 0px

  .web
    .header-linkAction
      headerLinkAction()
      a
        headerLinkItem()
    .header-content
      position fixed
      top 0
      left 0
      right 0
      height 50px
      line-height 50px
      overflow hidden
      background-color #fff
      padding 0 20px
      font-size $font-size-medium-x
      box-shadow 0 0 5px rgba(145, 145, 145, .3)
      box-sizing border-box
      z-index 5
      .header-title
        display inline-block
        max-width  70%
        overflow hidden
        text-overflow ellipsis
        white-space nowrap
      .header-action
        float right
        .header-back
          padding 5px 15px
          background-color $color-main
          color #fff
          border-radius 5px
          font-size $font-size-medium
          cursor pointer
    > .content-container
      width 1020px
      margin 70px auto 0
      position: relative
      background: #fff

  @media (max-width: 768px) {
    .content-container {
      max-width: 100%;
    }
  }

  @media (device-width: 375px)and (device-height: 812px)   {
    .ios .header-container {
      padding-top: 44px !important;
    }

    .ios {
      padding-bottom: 34px !important;
    }
  }
  @media (device-width: 414px) and (device-height: 896px)  {
    .ios .header-container {
      padding-top: 44px !important;
    }

    .ios {
      padding-bottom: 34px !important;
    }
  }
  .web
   .header-content
     .header-left
       height 100%
       text-align center
       background #ffffff
       font-family PingFangSC-Regular
       font-size 18px
       color #444444
       letter-spacing 0
       float left
       border-right 1px solid $color-border-default
       width 241px
       @media (min-width: 1440px){
        width 289px
       }
  .ios, .android
    position: absolute
    left: 0
    right: 0
    bottom: 0
    top: 0
    display: flex
    flex-direction: column
    > .content-container
      flex: 1
      overflow: auto
      position: relative
      .content-container-mobile
        position: absolute
        left: 0
        right: 0
        bottom: 0
        top: 0
        > .cube-scroll-wrapper
          font-size 14px
          > .cube-scroll-content
            height: 100%
            > .cube-scroll-list-wrapper
              height: 100%
        > .um-scroll
          > .cube-scroll-content
            height: auto
            min-height: 100% !important
            > .cube-scroll-list-wrapper
              height: auto
              min-height: 100% !important
    > .header-container
      > .header-inner
        display: flex
        justify-content: space-between
        align-items: center
        box-sizing border-box
        border-bottom: 1px solid #e3e3e9
        background: white
        position: relative
        .m-nav-right
          font-size: 0px
          margin-right: 8px
          i
            font-size: 22px
        .m-nav-left
          font-size: 22px !important
          height: 100%
          color: $nav-button-color
        .title
          /*text-align : left*/
          position: absolute
          bottom: 0
          top: 0
          max-width: 60%;
          margin: 0 auto;
          line-height: 56px;
          text-align: center
          overflow: hidden
          font-size: $nav-title-size-mobile
          color: $nav-title-color-mobile
          white-space: nowrap
          overflow: hidden
          text-overflow: ellipsis
          left: 50px
          right: 50px

  .android
    .header-container
      > .header-inner
        min-height: $nav-button-height-android
        .m-nav-left, .m-nav-right button
          position relative
          z-index 2
          width: 36px
          height: $nav-button-height-android
          font-size: $font-size-medium
          margin-bottom: 1px
        .m-nav-right.id-zone button, .m-nav-right.en-zone button
          width auto
  .ios
    .header-container
      padding-top: $nav-height-ios-x-pading-t
      > .header-inner
        height: $public-height-custom
        .m-nav-left, .m-nav-right button
          position relative
          z-index 2
          width: 36px
          height: $public-height-custom
          font-size: $font-size-medium
          margin-bottom: 1px
        .m-nav-right.id-zone button,.m-nav-right.en-zone button
          width auto
  .ios.h5 .header-container
    padding-top: 0 !important
  .work-detailwrap
    .el-dialog__body
      padding 0
  .socre_rule
    background-color #f3f3f3
</style>



// WEBPACK FOOTER //
// src/common/components/u-page.vue